import React from 'react'

const React_Coding_Practice_15 = () => {
  return (
    <div>
      <h1>Coding Pratice 15</h1>
    </div>
  )
}

export default React_Coding_Practice_15
